// ReactiveTracker — used during computed formula evaluation to collect dependencies
window.ReactiveTracker = {
	current: null,
	_stack: [],

	begin: function () {
		var tracker = {
			propertyDeps: [],   // [{ ownerId, propName }]
			arrayDeps: [],      // [{ array, index }]

			addPropertyDep: function (ownerId, propName) {
				for (var i = 0; i < this.propertyDeps.length; i++) {
					if (this.propertyDeps[i].ownerId == ownerId && this.propertyDeps[i].propName == propName)
						return;
				}
				this.propertyDeps.push({ ownerId: ownerId, propName: propName });
			},
			addDependency: function (array, index) {
				for (var i = 0; i < this.arrayDeps.length; i++) {
					if (this.arrayDeps[i].array === array && this.arrayDeps[i].index === index)
						return;
				}
				this.arrayDeps.push({ array: array, index: index });
			}
		};
		this._stack.push(this.current);
		this.current = tracker;
		return tracker;
	},

	end: function () {
		var tracker = this.current;
		this.current = this._stack.pop() || null;
		return tracker;
	}
};